export default "__VITE_ASSET__70ae8497__"